module.exports = __webpack_public_path__ + "static/media/logo5.369309d9.png";